import React from "react";
import moment from "moment";
import Select from "react-select";

import { Button, Icon } from "aible";
import { DropdownButton, MenuItem } from "react-bootstrap";

import HomeIcon from "images/EDG/HomeIcon.svg";
import SettingsIcon from "images/EDG/SettingsIcon.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faTrash } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import DistributionChart from "components/Gallery/Charts/DistributionChart";
import OutcomeChart from "components/Gallery/Charts/OutcomeChart";

import barChartIcon from "images/EDG/Charts/chart-bar.svg";
import lineChartIcon from "images/EDG/Charts/chart-line.svg";
import pieChartIcon from "images/EDG/Charts/chart-pie.svg";
import treeChartIcon from "images/EDG/Charts/chart-tree.png";
import areaChartIcon from "images/EDG/Charts/chart-area.svg";

import arrowUpIcon from "images/EDG/Charts/arrow-up.svg";
import arrowDownIcon from "images/EDG/Charts/arrow-down.svg";

import { VIEW_TYPE } from "containers/View/reducer";
import { CHART_TYPES, REPORT_CHART_SIZE, REPORT_CHART_TYPES } from "containers/Report/ReportReducer";

import styles from "./style.module.css";

export default class Report extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openDescription: {}
    };
  }

  // TODO: This should be its own container
  renderChart(id, chart, chartPosition) {
    const {
      history,
      deleteChart,
      moveChart,
      updateChartDescription,
      updateChartTitle,
      updateChartSize,
      updateChartType,
      updateViewField,
      updateStopReset,
      chartsOrder
    } = this.props;
    const { openDescription } = this.state;

    if (!chart) {
      return <div />;
    }

    const isEditDesc = openDescription[id] !== undefined;
    const isShowDesc = chart.description !== undefined && chart.description !== "";
    const refKey = "description_" + id;

    return (
      <div
        className={
          styles.chartHolder +
          " " +
          (chart.size === undefined || chart.size === REPORT_CHART_SIZE.SMALL ? styles.smallChart : "") +
          " " +
          (chart.size === REPORT_CHART_SIZE.MEDIUM ? styles.mediumChart : "") +
          " " +
          (chart.size === REPORT_CHART_SIZE.LARGE ? styles.largeChart : "")
        }
        key={id}
      >
        <div className={styles.cTitle}>
          <LineInput
            isMediumBox
            defaultValue={chart.title}
            isCleanEditable
            onChange={(val) => updateChartTitle(id, val)}
          />
          <div className={styles.cSettings}>
            <DropdownButton
              pullRight
              id="blueprint-dropdown-button"
              title={<img src={SettingsIcon} />}
              style={{
                padding: "4px",
                display: "flex"
              }}
              noCaret
            >
              <div className={styles.menuHeader}>{"Chart Size"}</div>
              <MenuItem onClick={() => updateChartSize(id, REPORT_CHART_SIZE.LARGE)}>
                <div className={styles.menuItemContent}>
                  <Icon type={"columnsThree"} className={styles.menuIcon} width={30} height={20} />
                  <div className={chart && chart.size === REPORT_CHART_SIZE.LARGE ? styles.selectedAction : ""}>
                    {"Large"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem onClick={() => updateChartSize(id, REPORT_CHART_SIZE.MEDIUM)}>
                <div className={styles.menuItemContent}>
                  <Icon type={"columnsTwo"} className={styles.menuIcon} width={30} height={20} />
                  <div className={chart && chart.size === REPORT_CHART_SIZE.MEDIUM ? styles.selectedAction : ""}>
                    {"Medium"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem onClick={() => updateChartSize(id, REPORT_CHART_SIZE.SMALL)}>
                <div className={styles.menuItemContent}>
                  <Icon type={"columnsOne"} className={styles.menuIcon} width={30} height={20} />
                  <div className={chart && chart.size === REPORT_CHART_SIZE.SMALL ? styles.selectedAction : ""}>
                    {"Small"}
                  </div>
                </div>
              </MenuItem>
              <div className={styles.menuHeader}>{"Chart Type"}</div>
              <MenuItem onClick={() => updateChartType(id, CHART_TYPES.BAR)}>
                <div className={styles.menuItemContent}>
                  <Icon src={barChartIcon} className={styles.menuIcon} size={16} />
                  <div
                    className={
                      (chart && chart.chartType === CHART_TYPES.BAR) || (chart && chart.chartType === undefined)
                        ? styles.selectedAction
                        : ""
                    }
                  >
                    {"Bar Chart"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => updateChartType(id, CHART_TYPES.PIE)}
                disabled={chart && chart.chartType === CHART_TYPES.PIE}
              >
                <div className={styles.menuItemContent}>
                  <Icon src={pieChartIcon} className={styles.menuIcon} size={16} />
                  <div className={chart && chart.chartType === CHART_TYPES.PIE ? styles.selectedAction : ""}>
                    {"Pie Chart"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => updateChartType(id, CHART_TYPES.TREEMAP)}
                disabled={chart && chart.chartType === CHART_TYPES.TREEMAP}
              >
                <div className={styles.menuItemContent}>
                  <Icon src={treeChartIcon} className={styles.menuIcon} size={16} />
                  <div className={chart && chart.chartType === CHART_TYPES.TREEMAP ? styles.selectedAction : ""}>
                    {"Treemap"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => updateChartType(id, CHART_TYPES.LINE)}
                disabled={chart && chart.chartType === CHART_TYPES.LINE}
              >
                <div className={styles.menuItemContent}>
                  <Icon src={lineChartIcon} className={styles.menuIcon} size={16} />
                  <div className={chart && chart.chartType === CHART_TYPES.LINE ? styles.selectedAction : ""}>
                    {"Line Chart"}
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => updateChartType(id, CHART_TYPES.AREA)}
                disabled={chart && chart.chartType === CHART_TYPES.AREA}
              >
                <div className={styles.menuItemContent}>
                  <Icon src={areaChartIcon} className={styles.menuIcon} size={16} />
                  <div className={chart && chart.chartType === CHART_TYPES.AREA ? styles.selectedAction : ""}>
                    {"Area Chart"}
                  </div>
                </div>
              </MenuItem>
              {chartPosition > 0 || chartPosition < chartsOrder.length - 1 ? (
                <div className={styles.menuDivider} />
              ) : (
                ""
              )}
              {chartPosition > 0 ? (
                <MenuItem onClick={() => moveChart(id, -1)}>
                  <div className={styles.menuItemContent}>
                    <Icon src={arrowUpIcon} className={styles.menuIcon} size={16} />
                    {"Move Chart Up"}
                  </div>
                </MenuItem>
              ) : (
                ""
              )}
              {chartPosition < chartsOrder.length - 1 ? (
                <MenuItem onClick={() => moveChart(id, 1)}>
                  <div className={styles.menuItemContent}>
                    <Icon src={arrowDownIcon} className={styles.menuIcon} size={16} />
                    {"Move Chart Down"}
                  </div>
                </MenuItem>
              ) : (
                ""
              )}
              <div className={styles.menuDivider} />
              <MenuItem
                onClick={() =>
                  this.setState({
                    openDescription: { ...openDescription, [id]: true }
                  })
                }
              >
                <div className={styles.menuItemContent}>
                  <Icon type={"chat"} className={styles.menuIcon} size={16} />
                  {"Add Description"}
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  updateStopReset(chart.datasetId, true);
                  updateViewField(chart.datasetId, chart.field);
                  history.push("/gallery/" + chart.datasetId);
                }}
              >
                <div className={styles.menuItemContent}>
                  <Icon type={"data"} className={styles.menuIcon} size={16} />
                  {"View in Dataset"}
                </div>
              </MenuItem>
              <MenuItem onClick={() => deleteChart(id)}>
                <div className={styles.menuItemContent}>
                  <Icon type={"timesDark"} className={styles.menuIcon} size={16} />
                  {"Remove Chart"}
                </div>
              </MenuItem>
            </DropdownButton>
          </div>
        </div>
        <div
          className={styles.dWrapper}
          style={{
            height: isEditDesc ? "calc(100% - 173px)" : isShowDesc ? "calc(100% - 143px)" : "calc(100% - 93px)"
          }}
        >
          {chart.type === REPORT_CHART_TYPES.DISTRIBUTION ? (
            <DistributionChart field={chart.field} showAxis chart={chart} />
          ) : (
            <OutcomeChart
              field={chart.field}
              outcome={chart.outcome}
              outcomeSuccess={chart.outcomeSuccess}
              chart={chart}
              hideTitle
            />
          )}
        </div>
        <div className={styles.commentHolder}>
          {isEditDesc ? (
            <div>
              <textarea
                className={styles.descriptionTextArea}
                ref={refKey}
                defaultValue={chart.description}
                spellCheck="false"
              />
              <div className={styles.cButtons}>
                <Button
                  onClick={() =>
                    this.setState({
                      openDescription: { ...openDescription, [id]: undefined }
                    })
                  }
                  style={{ padding: "4px" }}
                >
                  {"Cancel"}
                </Button>
                <Button
                  onClick={() => {
                    this.setState({
                      openDescription: { ...openDescription, [id]: undefined }
                    });
                    return updateChartDescription(id, undefined);
                  }}
                  style={{ padding: "4px", marginLeft: "10px" }}
                >
                  {"Delete"}
                </Button>
                <Button
                  onClick={() => {
                    this.setState({
                      openDescription: { ...openDescription, [id]: undefined }
                    });
                    updateChartDescription(id, this.refs[refKey].value);
                  }}
                  style={{
                    padding: "4px",
                    marginLeft: "auto",
                    marginRight: "20px"
                  }}
                  type="primary"
                >
                  {"Save"}
                </Button>
              </div>
            </div>
          ) : isShowDesc ? (
            <div
              className={styles.textDescription}
              onClick={() =>
                this.setState({
                  openDescription: { ...openDescription, [id]: true }
                })
              }
            >
              <textarea value={chart.description} onChange={() => {}} spellCheck="false" />
              {/* <div className={styles.editButton}>
                <Button
                  onClick={() =>
                    this.setState({
                      openDescription: { ...openDescription, [id]: true },
                    })
                  }
                  style={{ padding: "4px" }}
                >
                  {"Edit"}
                </Button>
                <Button
                  onClick={() => updateChartDescription(id, undefined)}
                  style={{ padding: "4px", marginLeft: "5px" }}
                >
                  {"Delete"}
                </Button>
              </div> */}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderHeader() {
    const { report, updateType, history } = this.props;

    return (
      <div className={styles.gHeader}>
        <div
          className={styles.homeIcon}
          onClick={() => {
            updateType(VIEW_TYPE.REPORTS);
            history.push("/");
          }}
        >
          <Button style={{ paddingLeft: "7px", paddingRight: "7px" }}>
            <img src={HomeIcon} />
          </Button>
        </div>
        <div className={styles.datasetHeader}>
          <div>
            <div className={styles.boldItem}>{report.name}</div>
            <div className={styles.subItem}>{moment.utc(report.created).local().format("MMMM Do YYYY, h:mm:ss a")}</div>
          </div>
        </div>
        <div className={styles.actionButtons}></div>
      </div>
    );
  }

  renderRightPanel() {
    return (
      <div
        className={styles.rightPanel}
        style={{
          width: "400px",
          overflow: "visible"
        }}
      >
        {this.renderLinkReport()}
      </div>
    );
  }

  renderLinkReport() {
    const { dataset, report, history } = this.props;

    const customStyles = {
      container: (base, state) => {
        return {
          ...base,
          zIndex: state.isFocused ? "999" : "1"
        };
      }
    };

    const linkedData = report && report.metadata && report.metadata.linkedData;
    if (!linkedData) {
      return <div />;
    }
    const linkedSource = linkedData.dashboardLoc && linkedData.dashboardLoc.label;
    return (
      <div className={styles.right}>
        <div className={styles.rightHeader}>{(linkedSource ? linkedSource + " " : "") + " Report Information"}</div>
        <div className={styles.rightContent}>
          <div className={styles.smallBold} style={{ marginTop: "10px" }}>
            {(linkedSource ? linkedSource + " " : "") + "Dashboard Link"}
          </div>
          <a href={linkedData.sourceURL} target="_blank">
            {linkedData.sourceURL}
          </a>
          <div className={styles.smallBold}>{"Description"}</div>
          <div className={styles.rightDescription}>{linkedData.description}</div>
          <div className={styles.smallBold}>
            <Icon type={"data"} style={{ marginRight: "6px" }} />
            {"Data Source"}
          </div>
          <a onClick={() => history.push("/gallery/" + linkedData.datasetId)}>
            {dataset ? dataset.name : "View Dataset"}
          </a>
          <div className={styles.smallBold} style={{ marginTop: "30px" }}>
            {"Metrics and Categories Graphed"}
          </div>
          <div>
            <div>{"Metrics (y-axis)"}</div>
            {linkedData.yColumns &&
              linkedData.yColumns.map((c, i) => (
                <div className={styles.smallSubitem} key={"yc-" + i}>
                  {c.label}
                </div>
              ))}
          </div>
          <div style={{ marginTop: "20px" }}>
            <div>{"Category (x-axis)"}</div>
            {linkedData.xColumns &&
              linkedData.xColumns.map((c, i) => (
                <div className={styles.smallSubitem} key={"xc-" + i}>
                  {c.label}
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { id, report, chartsOrder } = this.props;

    if (report === undefined) {
      return <div className={styles.notFound}>{"Report Not Found"}</div>;
    }

    const isLinkReport = report && report.metadata && report.metadata.linkedData;

    return (
      <div className={styles.report}>
        {this.renderHeader()}
        <div className={styles.reportContent + " " + (isLinkReport ? styles.showPanel : "")}>
          {isLinkReport ? (
            <div className={styles.reportWarning}>
              <div>
                <strong>{"Possible insights in the report"}</strong>
              </div>
              <div>
                {
                  "Aible doesn’t get access to your linked reports, but here are some charts you might see in the linked report if you accessed it."
                }
              </div>
            </div>
          ) : (
            ""
          )}
          {chartsOrder &&
            chartsOrder.map((chartKey, i) =>
              this.renderChart(
                chartKey,
                report.charts[Number(chartKey)]
                  ? report.charts[Number(chartKey)].data
                  : report.charts[Number(chartKey)],
                i
              )
            )}
        </div>
        {isLinkReport && this.renderRightPanel()}
      </div>
    );
  }
}
